export default __webpack_public_path__ + "static/media/para-1.813ce434.png";